import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { CalculationMethodFormValues } from '../utils/calculationMethodVisibility';

export const useResetCalculationMethodOnHide = (isVisible: boolean): void => {
  const { watch, setValue } = useFormContext<CalculationMethodFormValues>();

  useEffect(() => {
    if (!isVisible && watch('calculationMethod')) {
      setValue('calculationMethod', null);
    }
  }, [isVisible, setValue, watch]);
};
